import isValidIp from 'app/forms/validations/ip';

export default {
  message: 'This field requires one or more comma-separated IP addresses',
  fn: (value) => {
    let ips = value;
    if (!Array.isArray(value)) {
      ips = value.split(',');
    }

    return ips.length > 0 && ips.every((ip) => ip.indexOf('/') === -1 && isValidIp.fn(ip.trim()));
  }
};
